/**
 * App Color Palette — single source of truth.
 *
 * CSS custom properties in src/index.css mirror these values.
 * The MUI theme in src/styles/theme.ts consumes them directly.
 * Components that use inline styles (sx / style props) should import
 * from here rather than hardcoding hex strings.
 */

// ---------------------------------------------------------------------------
// Primary  — teal/cyan  hsl(195 100% 32%)
// ---------------------------------------------------------------------------
export const COLOR_PRIMARY = "#157698";
export const COLOR_PRIMARY_DARK = "#0d4e65";
export const COLOR_PRIMARY_LIGHT = "#1886ac";
export const COLOR_PRIMARY_EXTRA_LIGHT = "#769aa4ff";

// ---------------------------------------------------------------------------
// Secondary / Accent  — warm amber  hsl(47 100% 69%)
// ---------------------------------------------------------------------------
export const COLOR_SECONDARY = "#FCA51E";

// ---------------------------------------------------------------------------
// Semantic / Functional
// ---------------------------------------------------------------------------
export const COLOR_DESTRUCTIVE = "#d32f2f";
export const COLOR_DESTRUCTIVE_HOVER = "#f44336";
export const COLOR_SUCCESS = "#2e7d32";
export const COLOR_BLUE = "#1976d2";
export const COLOR_BLUE_HOVER = "#1565c0";
export const COLOR_GREEN_ACTIVE = "#e5fae5ff";
export const COLOR_GREEN_ACTIVE_DARK = "#4e7550ff";

// ---------------------------------------------------------------------------
// Neutral
// ---------------------------------------------------------------------------
export const COLOR_TEXT_PRIMARY = "#333333";
export const COLOR_TEXT_MUTED = "#546e7a";
export const COLOR_BG = "#fafafa";
export const COLOR_GREY_100 = "#e3e2e1";
export const COLOR_GREY_300 = "#777675";
export const COLOR_GREY_INACTIVE = "#bababaff";

// ---------------------------------------------------------------------------
// Shape tokens
// ---------------------------------------------------------------------------
export const BORDER_RADIUS = 8;   // px  — matches MUI theme shape.borderRadius
export const BORDER_RADIUS_PILL = 50;  // px  — used for pill-shaped CTA buttons
